import React, { useState } from 'react';
import CookieBot from 'react-cookiebot';
import { Span } from '.';
const domainGroupId = process.env.REACT_APP_COOKIETBOT_ID;

export function Bot(){
  const [hasCookieBot, setHasCookieBot] = useState(undefined);
  return (
      <div>
      <CookieBot domainGroupId={domainGroupId} />
      <Span style={{ color: 'red', marginVertical: 10 }}>
        {hasCookieBot && `Has CookieBot: ${JSON.stringify(hasCookieBot)}`}
      </Span>
      </div>
  );
}

